import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1 className="privacy-title">Integritetspolicy</h1>
        <p className="privacy-updated">Senast uppdaterad: {new Date().toLocaleDateString('sv-SE')}</p>

        <section className="privacy-section">
          <h2>1. Vilka vi är</h2>
          <p>
            Denna integritetspolicy beskriver hur SLDRS samlar in, använder och skyddar
            information när du besöker vår webbplats.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Cookies</h2>
          <p>
            Vår webbplats kan använda cookies för att förbättra din upplevelse och för att
            analysera hur webbplatsen används. Cookies är små textfiler som lagras i din
            webbläsare.
          </p>
          <p>
            När du besöker vår webbplats första gången ber vi om ditt samtycke innan
            icke-nödvändiga cookies aktiveras. Du kan när som helst ändra ditt val genom att
            rensa webbläsarens lagrade data för vår sida och ladda om sidan.
          </p>
          <p>Vi kan använda följande typer av cookies:</p>
          <ul>
            <li>
              <strong>Nödvändiga cookies:</strong> krävs för att webbplatsen ska fungera korrekt
              och kan inte stängas av.
            </li>
            <li>
              <strong>Analyscookies:</strong> hjälper oss förstå hur besökare använder webbplatsen,
              så att vi kan förbättra den. Används endast om du gett ditt samtycke.
            </li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. Kontaktformulär</h2>
          <p>
            När du skickar in vårt kontaktformulär samlar vi in de uppgifter du själv anger,
            till exempel namn, e-postadress, telefonnummer och meddelande. Dessa uppgifter
            används enbart för att kunna besvara din förfrågan och kontakta dig angående
            ditt ärende.
          </p>
          <p>
            Vi sparar inte dina uppgifter längre än nödvändigt för att hantera din förfrågan,
            och vi delar inte dina uppgifter med tredje part utan ditt samtycke.
          </p>
        </section>

        <section className="privacy-section">
          <h2>4. Dina rättigheter</h2>
          <p>Enligt dataskyddsförordningen (GDPR) har du rätt att:</p>
          <ul>
            <li>Begära information om vilka personuppgifter vi har om dig</li>
            <li>Begära att felaktiga uppgifter rättas</li>
            <li>Begära att dina uppgifter raderas</li>
            <li>Återkalla ditt samtycke till cookies eller databehandling</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>5. Kontakta oss</h2>
          <p>
            Om du har frågor om denna integritetspolicy eller hur vi hanterar dina
            personuppgifter, kontakta oss via vårt{' '}
            <a href="/KONTAKTA-OSS">kontaktformulär</a>.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Ändringar av denna policy</h2>
          <p>
            Vi kan komma att uppdatera denna integritetspolicy. Vid väsentliga ändringar
            informerar vi dig genom att uppdatera datumet högst upp på denna sida.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
